import * as React from 'react'
import { PlaybackContentLink } from '..'

export type OnPlay = (content: PlaybackContentLink) => void

type PlaybackAreaProps = {
  usePlayer: boolean
  onPlay: OnPlay
}

type PlayCallback = {
  onPlay: OnPlay | null
}

export const PlayerContext = React.createContext<PlayCallback>({ onPlay: null })

export const PlaybackArea: React.StatelessComponent<PlaybackAreaProps> = ({
  usePlayer,
  onPlay,
  children
}) => (
  <PlayerContext.Provider value={{ onPlay: usePlayer ? onPlay : null }}>
    {children}
  </PlayerContext.Provider>
)
